import React from "react";
import { Route, Routes } from "react-router-dom";
import CareProProfile from "./carepro_profile/carepro_profile.jsx";
import LinkExpired from "./carepro_profile/link_expired.jsx";
import TermsAndConditions from "./terms_and_conditions/terms_and_condition.jsx";
import JobRegistration from "./job_registration/job_registration_page.jsx";
import RCAdmission from "./digitalization_of_RC_admissions/RC_admission.jsx";
import EInvoiceForm from "./e_invoice/e_invoice_request_form.jsx";
import GeneralSurveyPages from "./survey/GeneralSurveyPages.jsx";
import CareProProfile2 from "@/ts-lib/cg-profile/App.tsx";
import TailwindLayout from "@/ts-lib/tailwind.tsx";
import RCNew from "@/ts-lib/rc-new/App.tsx";
import HealthTracker from "@/ts-lib/health-tracker/App.tsx";
import HealthTrackerProfessional from "@/ts-lib/health-tracker/monthly-report/ProfessionalRoute.tsx";
import JobPortal  from "@/ts-lib/cg-job/App.tsx";
import IssueBox from "@/ts-lib/issue-box/App.tsx";
import CareProUpdatePage from "./carepro_update/CareProUpdatePage.jsx";
import DeliveryDetail from "./delivery/delivery_detail.jsx";
import MaintenanceAccessPage from "./maintenance/MaintenanceAccessPage.jsx";
import MaintenanceTaskListPage from "./maintenance/MaintenanceTaskListPage.jsx";
import MaintenanceTaskDetailPage from "./maintenance/MaintenanceTaskDetailPage.jsx";
const tailwindConfig = {
  theme: {
    extend: {
      colors: {
        // RCNewConfiguration
        primary: "#5A46AA",
        "primary-light": "#A2ADD6",
        accent: "#FF885C",
        "accent-yellow": "#FFDE78",
        "accent-green": "#3d8f7f",
        "light-bg": "#F7F8FC",
        "light-gray": "#E8E9F1",

        // healthTrackerConfig
        "brand-primary": "#5A46AA",
        "brand-primary-light": "#F4F2FF",

        // jobConfigurations
        "brand-purple": "#5A46AA",
        "brand-yellow": "#FFDE78",
        "brand-orange": "#FF885C",
        "brand-light-purple": "#A2ADD6",
        "brand-green": "#53D87F", 
        "brand-gray": "#F3F4F6",
      },

      // If you want ONE shared sans stack, combine them (rather than overriding "sans")
      fontFamily: {
        sans: [
          "Inter",
          "Open Sans",
          "Tahoma",
          "Verdana",
          '"Noto Sans"',
          "sans-serif",
        ],

        // Optional: keep explicit aliases too (handy if different apps want different defaults)
        inter: ["Inter", "sans-serif"],
        opensans: ["Open Sans", "sans-serif"],
        legacy: ['Tahoma', 'Verdana', '"Noto Sans"', "sans-serif"],
      },

      // healthTrackerConfig animations
      keyframes: {
        "fade-in": {
          "0%": { opacity: "0" },
          "100%": { opacity: "1" },
        },
        "fade-in-up": {
          "0%": { opacity: "0", transform: "translateY(20px)" },
          "100%": { opacity: "1", transform: "translateY(0)" },
        },
        "pulse-highlight": {
          "0%, 100%": { "border-color": "rgb(203, 213, 225)", outline: "2px solid transparent" },
          "50%": { "border-color": "rgb(90, 70, 170)", outline: "2px solid rgba(90, 70, 170, 0.4)" },
        },
      },
      animation: {
        "fade-in": "fade-in 0.5s ease-out forwards",
        "fade-in-up": "fade-in-up 0.6s ease-out forwards",
        "pulse-highlight": "pulse-highlight 2s ease-in-out infinite",
      },
    },
  },
};

// export default mergedTailwindConfig;


export default function Router() {
  return (
    <Routes>
      <Route path="/carepro_update" element={<CareProUpdatePage />} />
      <Route path="/old.profile" element={<CareProProfile />} />
      <Route path="/link-expired" element={<LinkExpired />} />
      <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
      <Route path="/job_registration" element={<JobRegistration />} />
      <Route path="/resident_admission_form" element={<RCAdmission />} />
      <Route path="/e_invoicing" element={<EInvoiceForm />} />
      <Route path="/survey_form" element={<GeneralSurveyPages />} />
      <Route path="/profile" element={<CareProProfile2 />} />
      <Route
        path="/rc"
        element={
          <TailwindLayout
            config={tailwindConfig}
            scripts={[
              "https://cdn.tailwindcss.com",
              "https://maps.googleapis.com/maps/api/js?key=AIzaSyDGrproe8Lb2BQEDwqld-hOUk3l1-uBUPg&libraries=places",
            ]}
          >
            <RCNew />
          </TailwindLayout>
        }
      />
      <Route
        path="/health_tracker"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}> 
            <HealthTracker />
          </TailwindLayout>
        }
      />
      <Route
        path="/health-tracker/professional"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}>
            <HealthTrackerProfessional />
          </TailwindLayout>
        }
      />
      <Route
        path="/cg_jobs/*"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}>
            <JobPortal />
          </TailwindLayout>
        }
      />
      <Route
        path="/maintenance/access/:token"
        element={<MaintenanceAccessPage />}
      />
      <Route
        path="/maintenance/tasks"
        element={<MaintenanceTaskListPage />}
      />
      <Route
        path="/maintenance/tasks/:issueId"
        element={<MaintenanceTaskDetailPage />}
      />
      <Route
        path="/maintenance"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}>
            <IssueBox />
          </TailwindLayout>
        }
      />
      <Route
        path="/public/delivery/:deliveryRequestId"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}>
            <DeliveryDetail />
          </TailwindLayout>
        }
      />
      <Route
        path="/delivery/confirm/:deliveryRequestId"
        element={
          <TailwindLayout config={tailwindConfig} scripts={["https://cdn.tailwindcss.com"]}>
            <DeliveryDetail />
          </TailwindLayout>
        }
      />
    </Routes>
  );
}
